import * as streamsLib from "Lib/streams";
import { defineStore } from "pinia";

import useAdminStore from "VueStore/admin/general";

export default defineStore('streams', {
  state: () => ({
    global_streams: [],
    customer_streams: [],
  }),
  actions: {
    async fetchAll(customer) {
      const cust = customer ?? useAdminStore().customer;
      this.fetchGlobalStreams();
      if (cust) this.fetchCustomerStreams(cust);
    },
    async fetchGlobalStreams() {
      this.global_streams = (await streamsLib.fetchGlobalStreams()) ?? [];
    },
    async fetchCustomerStreams(customer) {
      this.customer_streams = (await streamsLib.fetchCustomerStreams(customer)) ?? [];
    },
    // ...Object.entries(streamsLib)
    //   .filter(([fn_name]) => ![
    //     'fetchGlobalStreams',
    //     'fetchCustomerStreams',
    //   ].includes(fn_name))
    //   .reduce((acc, [fn_name, fn]) => ({
    //     ...acc,
    //     [fn_name]: new Proxy(fn, {
    //       apply: async (target, _, args) => {
    //         const ret = await target(...args);
    //         this.fetchGlobalSteams();
    //         return ret;
    //       },
    //     }),
    //   }), {}),
    async storeStream(stream) {
      await streamsLib.storeStream(stream);
      this.fetchAll();
    },
    async updateStreams(customer, streams) {
      await streamsLib.updateStreams(customer, streams);
      this.fetchAll(customer);
    },
    async patchStream(old_name, stream) {
      await streamsLib.patchStream(old_name, stream);
      this.fetchAll();
    },
    async destroyStream(stream) {
      await streamsLib.destroyStream(stream);
      this.fetchAll();
    },
  },
});
